import { observer } from 'mobx-react';
import { Document as DocumentType } from '@roc/feature-types';
import { StandardDialog } from '@roc/ui';
import { CustomTaskDialog } from '@roc/feature-general-tasks';
import { SettlementDetailsForm } from './settlementDetailsForm';

export type SettlementDetailsItemProps = {
  open: boolean;
  onClose: () => void;
  document?: DocumentType;
  expand?: boolean;
  loanId: string;
};

export const SettlementDetailsItem = observer(
  ({ open, onClose, document, expand = true, loanId }: SettlementDetailsItemProps) => {

    const dialogContent = (
      <SettlementDetailsForm handleClose={onClose} document={document} expand={expand} loanId={loanId} />
    );

    return (
      <>
        {document?.taskId ? (
          <CustomTaskDialog
            open={open}
            title="Settlement Details"
            handleClose={onClose}
            dialogContent={dialogContent}
            taskId={document.taskId}
          />
        ) : (
          <StandardDialog
            open={open}
            title="Settlement Details"
            maxWidth="sm"
            handleClose={onClose}
            dialogContent={dialogContent}
          />
        )}
      </>
    );
  }
);

export default SettlementDetailsItem;
